module.exports = {
	API_URL: "https://tanktrack.itqu.be/api/"
}